import styled, { useTheme } from 'styled-components';
import Markdown from 'react-markdown';
import { useUser } from '@gif/shared-rtk';
import { useGetHubContentQuery } from '../../api';
import { useAppSelector, useAppDispatch } from '../../store';

/* eslint-disable-next-line */
export interface FooterLegalProps {}

const LegalText = styled(Markdown)<{ $theme: any }>`
  padding: 1rem 0;
  align-self: center;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.125rem;
  color: ${({ $theme }) => $theme.legalTextColor};

  p {
    margin: 0;
  }

  a {
    letter-spacing: 0.015rem;
    font-weight: 700;
    color: ${({ $theme }) => $theme.legalTextColor};
  }
`;

export function FooterLegal(props: FooterLegalProps) {
  const theme = useTheme();
  const { user, isLoading: isUserLoading } = useUser({
    useAppSelector,
    useAppDispatch,
  });
  const uid = user.accessToken?.claims?.uid;
  const { data, isLoading } = useGetHubContentQuery(
    {
      uid,
    },
    { skip: isUserLoading }
  );
  const footerMessage = data?.result.footerMessage || '';

  if (isLoading) return null;

  return <LegalText $theme={theme}>{footerMessage}</LegalText>;
}

export default FooterLegal;
